// ATLAS-63098
export const JIRA_FAMILIARITY_SESSION_STORAGE = 'jira-familiarity';
